/* eslint-disable */
export default {
  feedbackHeader: 'Envoyer un commentaire',
  back: 'Retour',
  revert: 'Rétablir',
  instruction:
    'Nous accordons beaucoup d’importance à vos commentaires. N’hésitez pas à nous contacter si vous rencontrez des problèmes avec l’application, si vous souhaitez obtenir une fonctionnalité ou pour signaler un bogue.',
  fillForm: 'Veuillez remplir le formulaire ci-dessous et cliquer ',
  useMailBox: ' ou utilisez votre boîte mail et envoyez une demande à ',
  email: 'Votre adresse e-mail',
  reply: '(pour que nous puissions vous répondre)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'Rubrique du commentaire',
  topicPlaceHolder: 'Veuillez choisir une option',
  bugReport: 'Signalement de bug',
  featureRequest: 'Demande de fonctionnalité',
  others: 'Autres',
  subject: 'Objet',
  subjectPlaceHolder: 'Que pouvons-nous faire pour vous aider ?',
  description: 'Description complète',
  descriptionPlaceHolder: 'Veuillez saisir autant de détails que possible',
  send: 'Envoyez votre commentaire',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
